import { render, staticRenderFns } from "./DentatsuCategorySelect.vue?vue&type=template&id=06aab756&"
import script from "./DentatsuCategorySelect.vue?vue&type=script&lang=js&"
export * from "./DentatsuCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports